// extracted by mini-css-extract-plugin
module.exports = {"inline-checkbox":"Checkbox_inline-checkbox__1qeVJ","container":"Checkbox_container__HSQbX","label":"Checkbox_label__1_fGw","inline-container":"Checkbox_inline-container__2YZ7n"};